// extracted by mini-css-extract-plugin
export default {"product":"ProductGrid_product__g5AtG","thumb":"ProductGrid_thumb__V3Cu-","content":"ProductGrid_content__2r+81","price":"ProductGrid_price__gse52"};